import React from "react";
import { Linkedin, Instagram, Mail } from "lucide-react";
import { PROFILE } from "../../data";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-navy-deep text-white/50 border-t border-white/10">
      <div className="mx-auto max-w-7xl section-x py-10 flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-2 font-serif text-white text-lg">
          <span className="inline-block w-2 h-2 bg-berry rotate-45" />
          {PROFILE.name}
        </div>
        <p className="text-sm order-3 sm:order-2">© {new Date().getFullYear()} {PROFILE.name}. All rights reserved.</p>
        <div className="flex items-center gap-3 order-2 sm:order-3">
          <a href={PROFILE.linkedin} target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" aria-label="LinkedIn" className="inline-flex items-center justify-center w-10 h-10 rounded-sm bg-white/10 hover:bg-berry text-white transition-colors duration-200">
            <Linkedin size={18} />
          </a>
          <a href={PROFILE.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="inline-flex items-center justify-center w-10 h-10 rounded-sm bg-white/10 hover:bg-berry text-white transition-colors duration-200">
            <Instagram size={18} />
          </a>
          <a href={`mailto:${PROFILE.email}`} data-testid="footer-email" aria-label="Email" className="inline-flex items-center justify-center w-10 h-10 rounded-sm bg-white/10 hover:bg-berry text-white transition-colors duration-200">
            <Mail size={18} />
          </a>
        </div>
      </div>
    </footer>
  );
};
